import { Effect, Layer, Scope } from "effect";
import { frontendThemeFailure } from "./theme-model.ts";
import { ThemeStyleIo } from "./theme-service.ts";

export const ThemeStyleIoLive = Layer.succeed(ThemeStyleIo, ThemeStyleIo.of({
  connect: Effect.gen(function* () {
    const owner = yield* Scope.Scope;
    if (owner.state._tag === "Closed") return yield* Effect.interrupt;
    const id = yield* Effect.try({ try: () => "theme-" + crypto.randomUUID(), catch: frontendThemeFailure });
    if (typeof document === "undefined") return { scopeId: id, write: () => Effect.void };
    const element = yield* Effect.acquireRelease(
      Effect.try({ try: () => {
        const element = document.createElement("style");
        element.id = "opencode-" + id;
        element.dataset.component = "opencode-theme";
        element.dataset.themeScope = id;
        return element;
      }, catch: frontendThemeFailure }),
      element => Effect.try({ try: () => element.remove(), catch: frontendThemeFailure }).pipe(Effect.orDie)
    );
    yield* Effect.try({ try: () => { document.head.appendChild(element); }, catch: frontendThemeFailure });
    return { scopeId: id, write: (css: string) => Effect.try({ try: () => { element.textContent = css; }, catch: frontendThemeFailure }) };
  })
}));
